import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Typography from '@material-ui/core/Typography';
import getStatusLabel from '../../utils/getHandlingListStatusLabel';

const HandlingListStatus = ({ handlingList }) => {
  const intl = useIntl();

  return <Typography variant="body2">{getStatusLabel(handlingList, intl)}</Typography>;
};

HandlingListStatus.propTypes = {
  handlingList: PropTypes.object.isRequired,
};

export default HandlingListStatus;
